import { BaseMutations } from '@/store/base-mutations';
import { del_mask } from '@/utils';
import ConferencesState from './state';
import { Conferences, ConferencesFilters } from '../types';

export default class ConferencesMutations extends BaseMutations<ConferencesState> {
  SET_CONFERENCES(items: Conferences.Conference[]) {
    this.state.conferences = items;
  }

  SET_NEW_CONFERENCE_RESPONSE(items: Conferences.NewConferenceRespone) {
    this.state.news_conference_responce = items;
  }

  SET_NEW_CONFERENCE_RESPONSE_TYPE(value: { id: number, slug: string, name: string }) {
    this.state.news_conference_responce.type = value;
  }

  SET_CONFERENCE_DETAIL(items: Conferences.ConferenceDetail) {
    this.state.conference_detail = items;
  }

  SET_ORGANIZATION(items: string[]) {
    this.state.organizations = items;
  }

  SET_STATUSES(items: string[]) {
    this.state.statuses = items;
  }

  UPD_NOMECLATURES(items: Conferences.Nomenclature[]) {
    this.state.news_conference_responce.nomenclatures = items;
  }

  UPD_USERS(items: Conferences.AddUser[]) {
    this.state.new_conference.users = items;
  }

  TOGGLE_CONFERENCES_LOADING(value: boolean) {
    this.state.conferences_loading = value;
  }

  UPD_FILTER_KEY({ key, value }: { key: keyof ConferencesFilters, value: unknown }) {
    this.state.filters[key] = value;
  }

  UPD_NEW_CONFERENCE_KEY<T extends keyof Conferences.NewConference>({ key, value }: { key: T, value: Conferences.NewConference[T] }) {
    this.state.new_conference[key] = value;
  }

  UPD_USERS_KEY({ key, value }: { key: keyof Conferences.AddUser, value: unknown }) {
    this.state.add_users_fileds[key] = value;
  }

  CLEAR_USERS_FIELD() {
    this.state.add_users_fileds.full_name = null;
    this.state.add_users_fileds.birthday = null;
    this.state.add_users_fileds.user_id = null;
    this.state.add_users_fileds.phone = null;
    this.state.add_users_fileds.position = null;
    this.state.add_users_fileds.email = '';
  }

  ADD_USER_TO_CONFERENCE(user: Conferences.AddUser) {
    if (user.phone !== null) {
      user.phone = del_mask(user.phone);
    }

    if (!user.user_id) {
      this.state.new_conference.users.push(user);
    } else {
      const index = this.state.new_conference.users.findIndex((u) => u.user_id === user.user_id);

      if (index < 0) {
        this.state.new_conference.users.push(user);
      } else {
        this.state.new_conference.users[index] = user;
      }
    }
  }

  REMOVE_USER_FROM_CONFERENCE(index: number) {
    if (index >= 0 && index < this.state.new_conference.users.length) {
      this.state.new_conference.users.splice(index, 1);
    }
  }

  TOGGLE_SUCCESS_DIALOG(value: boolean) {
    this.state.show_success_dialog = value;
  }

  TOGGLE_EDIT_SUCCESS_DIALOG(value: boolean) {
    this.state.is_edit_success_dialog = value;
  }

  TOGGLE_USERS_LOADING(value: boolean) {
    this.state.users_loading = value;
  }

  TOGGLE_ROLE_DIALOG(value: boolean) {
    this.state.show_role_dialog = value;
  }

  SET_ROLE_DIALOG(value: string) {
    this.state.roles_message = value;
  }

  TOGGLE_NOT_FOUND_DIALOG(value: boolean) {
    this.state.show_not_found_dialog = value;
  }
}
